import { Button } from "primereact/button";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { formatDate } from "../../shared/CommonFunctions";
import FormDirtyListener from "../formListener/FormDirtyListener";

export interface ComponentHeaderProps {
  dateCreated?: string;
  userCreated?: string;
  editPath?: string;
  showEdit?: boolean;
  backPath?: string;
  showBack?: boolean;
  label?: string;
}

export default function ComponentHeader({
  dateCreated,
  userCreated,
  editPath,
  showEdit = false,
  backPath,
  showBack = false,
  label,
}: ComponentHeaderProps) {
  const navigate = useNavigate();

  const [isDirty, setIsDirty] = useState(false);

  return (
    <>
      {showBack && backPath && <FormDirtyListener onDirtyChange={setIsDirty} />}
      <div className="w-full border-0 shadow-none comp-header">
        <div className="flex justify-between items-center w-full mb-3 border-purple border-2 text-purple font-bold flex-wrap header-height">
          <div>
            <h4 className="text-purple flex items-center">
              <span className="pl-1 mx-1 mt-0"></span>
              <span>{label}</span>
            </h4>
          </div>
          <div>
            {userCreated != null && (
              <>
                <span className="user-icon icon-spec ml-3 "></span> <span className="mr-2"> {userCreated}</span>
                <span className="time-stamp icon-spec "></span> <span>{formatDate(dateCreated!)}</span>
              </>
            )}
          </div>
          <div className="dont-show-in-print ">
            {showEdit && editPath && (
              <Button onClick={() => navigate(editPath ?? "")} label="Edit" className="bg-transparent text-purple mr-2 edit-icon" />
            )}{" "}
            {showBack && backPath && (
              <Button
                id="backBtn"
                onClick={() => {
                  if (!isDirty) {
                    navigate(backPath);
                  }
                }}
                label="Back"
                className="bg-transparent border-0! text-purple mr-2 back-icon"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
